import { useState } from 'react';
import Banner from './componentes/Banner/Banner';
import Formulario from './componentes/Formulario';
import Time from './componentes/Time';

function App() {

const times = [
  {
    nome: 'Programação',
    corPrimaria: '#57C278',
    corSecundaria: '#D9F7E9'
  },
  {
    nome: 'Front-End',
    corPrimaria: '#82CFFA',
    corSecundaria: '#E8F8FF'
  },
  {
    nome: 'Data Science',
    corPrimaria: '#A6D157',
    corSecundaria: '#F0F8E2'
  },
  {
    nome: 'Devops',
    corPrimaria: '#E06B69',
    corSecundaria: '#FDE7E8'
  },
  {
    nome: 'UX e DEsign',
    corPrimaria: '#DB6EBF',
    corSecundaria: '#FAE9F5'
  },
  {
    nome: 'Mobile',
    corPrimaria: '#FFBA05',
    corSecundaria: '#FFF5D9'
  },
  {
    nome: 'Inovação e Gestão',
    corPrimaria: '#FF8A29',
    corSecundaria: '#FFEEDF'
  }
]

  const [equipes, setEquipes] = useState([])

  const aoNovoColaboradorCadastrado = (colaborador) => {
    console.log("colaborador cadastrado: ", colaborador)
    setEquipes([...equipes, colaborador])
    console.log("Todas as equipes", equipes);    
  }

  return (
    <div className="App">
      <Banner />

      <Formulario 
        aoColaboradorCadastrado = {colaborador => aoNovoColaboradorCadastrado(colaborador)}
        times={times.map(time => time.nome)}
      />

      {times.map(time => 
        <Time 
          key={time.nome}
          nome={time.nome} 
          corSecundaria={time.corSecundaria}
          corPrimaria={time.corPrimaria}
          colaboradores={equipes.filter(colaborador => colaborador.time === time.nome)}
        />
      )}

    </div>
  );
}

export default App;
